import React from "react";
import { compose } from "containers/HOC";
import { withFarmGroup, withAggregatedReporting } from "containers/Reporting/ReportingHOC";
import { useModal } from "common/effects";
import Page from "components/Page";
import PageBody from "components/PageBody";
import ActionLink from "components/ActionLink";
import Loader from "components/Loader";
import NotFound from "components/NotFound";
import FarmGroupDetailsModal from "./FarmGroupDetailsModal";
import InviteFarmGroupMembersModal from "./InviteFarmGroupMembersModal";
import FarmTagsModal from "containers/FarmTags/FarmTagsModal";
import Reporting from "containers/Reporting/Reporting";

const FarmGroup = (props) => {
    const { online, farms, farmGroup, reloadFarmGroup, reloadFarmTags } = props;
    const { openModal, getModal } = useModal();

    const manageGroup = () => {
        openModal("FarmGroupDetailsModal", { farmGroup }, reloadFarmGroup);
    };
    const manageGroupModal = getModal("FarmGroupDetailsModal");

    const inviteMembers = () => {
        openModal("InviteFarmGroupMembersModal", { farmGroup }, reloadFarmGroup);
    };
    const inviteMembersModal = getModal("InviteFarmGroupMembersModal");

    const tagFarms = () => {
        openModal("FarmTagsModal", { farms }, reloadFarmTags);
    };
    const farmTagsModal = getModal("FarmTagsModal");

    const loading = !farmGroup;
    const hasFarmGroup = farmGroup && farmGroup.id;
    const farmGroupNotFound = farmGroup && !farmGroup.id;
    const isFarmGroupAdmin = farmGroup && farmGroup.role === "Admin";

    return (
        <>
            <Page>
                <section className="PageHead">
                    <div className="Container">
                        <div className="FarmTitle">
                            {farmGroup && (
                                <div className="FarmTitle-heading FarmTitle-heading--lg">
                                    <span id="page-head-title" className="FarmTitle-name" title={farmGroup.name}>
                                        {farmGroup.name}
                                    </span>
                                    <div id="page-head-sub-title" className="FarmTitle-sub" title={farmGroup.description}>
                                        {farmGroup.description}
                                    </div>
                                </div>
                            )}
                        </div>
                        {isFarmGroupAdmin && (
                            <div className="PageHead-actions u-print-none">
                                <ActionLink id="manage-settings" className="IconLink--settings u-link" onClick={manageGroup}>
                                    Manage farm group settings
                                </ActionLink>
                                <ActionLink id="invite-members-link" className="IconLink--arrow-plus u-link" onClick={inviteMembers}>
                                    Invite new members
                                </ActionLink>
                                {online && farms && farms.length > 0 && (
                                    <ActionLink id="tag-farms-link" className="IconLink--tag u-link" onClick={tagFarms}>
                                        Tag farms
                                    </ActionLink>
                                )}
                            </div>
                        )}
                    </div>
                </section>
                <PageBody>
                    {loading && <Loader />}
                    {farmGroupNotFound && <NotFound />}
                    {hasFarmGroup && <Reporting {...props} inviteMembers={inviteMembers} />}
                </PageBody>
            </Page>
            {manageGroupModal && <FarmGroupDetailsModal {...manageGroupModal.modalProps} />}
            {inviteMembersModal && <InviteFarmGroupMembersModal {...inviteMembersModal.modalProps} />}
            {farmTagsModal && <FarmTagsModal {...farmTagsModal.modalProps} />}
        </>
    );
};

export default compose(withFarmGroup, withAggregatedReporting)(FarmGroup);
